<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-2">
        <b-field>
          <form-input label="№" type="number" v-model="form.order_num"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('issues.title')} *`" v-model="form.name"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-select :label="`${$t('issues.state')} *`" v-model="form.state">
            <option value="new">{{ $t('projectControl.issueStatuses.new') }}</option>
            <option value="in_process">{{ $t('projectControl.issueStatuses.in_process') }}</option>
            <option value="completed">{{ $t('projectControl.issueStatuses.completed') }}</option>
            <option value="cancelled">{{ $t('projectControl.issueStatuses.cancelled') }}</option>
            <option value="paused">{{ $t('projectControl.issueStatuses.paused') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea :label="$t('interface.description')" v-model="form.description"></form-textarea>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="$t('issues.department')" v-model="form.department">
            <option v-for="department in departments" :value="department.id">
              {{ department.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <EmployeeSelect :initials="form.employee__name"
                          :label="$t('issues.employee')"
                          v-model="form.employee">
          </EmployeeSelect>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :label="`${$t('issues.startDate')} *`" v-model="form.start_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :label="`${$t('issues.term')} *`" v-model="form.term_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :label="$t('issues.startedDate')" v-model="form.started_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :label="$t('issues.completedDate')" v-model="form.completed_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDate} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'

  const defaultIssueData = {
    name: '',
    description: '',
    state: 'new',
    employee: '',
    employee__name: '',
    department: '',
    start_date: new Date(),
    term_date : new Date(),
    started_date: null,
    completed_date: null,
    order_num: null
  }

  export default {
    props: ['issueData', 'editMode'],
    components: {EmployeeSelect},
    data() {
      return {
        form: this.issueData || {...defaultIssueData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.name === '') {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            start_date: prepareDate(this.form.start_date),
            term_date: prepareDate(this.form.term_date),
            started_date: this.form.started_date ? prepareDate(this.form.started_date) : null,
            completed_date: this.form.completed_date ? prepareDate(this.form.completed_date) : null,
            order_num: this.form.order_num === '' ? null : this.form.order_num
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.$store.dispatch('Issue/getRelations', this.$route.params.projectId)
    },
    computed: {
      ...mapState('Issue', ['departments'])
    },
    watch: {
      issueData(data) {
        this.form = data
      }
    }
  }
</script>